import src from "IMAGE";
export default { src, width: 21, height: 6, blurWidth: 0, blurHeight: 0};
